/**
 * Image URL Constants
 * Centralized location for all placeholder and default images
 */

// Default placeholder images
export const PLACEHOLDER_IMAGES = {
  room: '/static/images/kitchen.jpg',
  house: '/static/images/placeholder_house.png',
};

/**
 * Get room image URL with fallback to placeholder
 * @param {Object} room - Room object with optional images or image_filename
 * @returns {string} - Image URL
 */
/**
 * Get item image URL — returns null when no image exists OR when the API
 * could not produce a fetchable URL (e.g. R2 presigning failed). Callers
 * should render a category icon or generic placeholder when this is null.
 *
 * The API's `url` field is authoritative: it's already either the presigned
 * R2 URL or the legacy /static/uploads path, depending on how the image was
 * stored. Never fall back to /static/uploads/items/<filename> here — for
 * R2-backed images that file does not exist on disk and would 404.
 */
export const getItemImageUrl = (item) => {
  if (item?.images && item.images.length > 0) {
    const primaryImage = item.images.find(img => img.is_primary) || item.images[0];
    return primaryImage.url || null;
  }
  return null;
};

export const getRoomImageUrl = (room) => {
  if (room?.images && room.images.length > 0) {
    const primaryImage = room.images.find(img => img.is_primary) || room.images[0];
    return primaryImage.url || null;
  }
  if (room?.image_filename) {
    return `/static/uploads/rooms/${room.image_filename}`;
  }
  return PLACEHOLDER_IMAGES.room;
};
